<style>
.zulu_lod_section h3 {
  text-align: center;
  margin-bottom: 5px;
}
.zulu_lod_section p {
  font-size: 14px;
}
.zulu_lod_section li {
  margin-left: 5px;
}
.zulu_lod_section .infoSection {
  text-align: center;
  padding: 0px 40px;
}
</style>
<template>
  <div>
    <!--loader - message--->
    <complete-loading
      :pageloader_value="pageLoader"
      :type="'complete'"
      v-if="pageLoader"
    ></complete-loading>

    <div v-if="!hasConsent()">
      <div class="col-12 col-md-12 whiteBG" v-if="showStep">
        <section class="blockElement p-4">
          <div class="row justify-content-between align-items-center">
            <div class="col-12 col-md-6">
              <div class="mamPamm-content">
                <h2 class="mb-3">{{ $t("zulu_trade") }}</h2>
                <p>{{ $t("zulu_zulitradeinfo") }}</p>

                <div class="d-flex align-items-center mt-3">
                  <a
                    v-if="get_user.verified_status == 0"
                    class="disabled common_btn btn_xs mr-2"
                    href="javascript:void(0);"
                    >{{ $t("suceessMsz24") }}</a
                  >
                  <a
                    v-else
                    class="common_btn btn_xs mr-2"
                    href="javascript:void(0);"
                    @click="createAccountEvent"
                    >{{ $t("zulu_createAccount") }}</a
                  >
                </div>
              </div>
            </div>
            <div class="col-12 col-md-5">
              <div class="mamPamm text-center">
                <img
                  src="static/fxView/images/zulu_trade-1.svg"
                  alt="Zulu Trade"
                />
              </div>
            </div>
          </div>
        </section>
        <section class="blockElement p-4">
          <div class="main-title">
            <h3>{{ $t("zulu_setupzulutrade") }}</h3>
            <!-- <p>How to setup ZuluTrade account</p> -->
          </div>
          <div class="mamPamm-feature mt-4">
            <ul class="listing flexible">
              <li class="py-1 my-1">
                <feather type="check"></feather>
                <p class="m-0">{{ $t("zulu_registeropen") }}</p>
              </li>
              <!-- <li>
                <feather type="check"></feather>
                <p class="m-0">{{ $t("zulu_findaccount") }}</p>
              </li> -->

              <li class="py-1 my-1">
                <feather type="check"></feather>
                <p class="m-0">{{ $t("zulu_logintozulu") }}</p>
              </li>
            </ul>
          </div>
        </section>
      </div>

      <div v-else class="middleBox inMiddle-area radius whitebox p-4">
        <div class="row">
          <div class="scrollbar height65">
            <div
              class="zulu_lod_section"
              v-html="
                $t('zulu_lod', {
                  name: getUserProfile.username,
                  date: date,
                })
              "
            ></div>
          </div>
          <div class="col-12 col-md-12 mt-3">
            <label class="d-flex align-items-center"
              ><input class="mr-2" type="checkbox" v-model="agreeTerms" /> I agree to the
              terms and conditions mentioned above</label
            >
            <div
              class="full-width submitButton justify-content-center align-items-center d-flex mt-3 w-100"
            >
              <button
                :disabled="!agreeTerms"
                :class="!agreeTerms ? 'disabled' : ''"
                class="prism_btn btn_sm"
                v-on:click="submitConsent()"
              >
                {{ $t("Continue") }}
              </button>
            </div>
          </div>
        </div>
      </div>
    </div>
    <div v-else>
      <div v-if="!congratulation_module && !showForm && zuluAccounts.length">
        <div class="whiteBG radius pt-3">
          <div
            class="d-flex flex-wrap tabcenter justify-content-end border-bottom pb-3 mb-2"
          >
            <div
              class="accountType d-flex justify-content-end align-items-center"
            >
              <a class="active" href="#" @click="showForm = true"
                >Create Zulu Account</a
              >
            </div>
            <div class="col-12 inMiddle-area table-responsive">
              <table class="table customize">
                <thead>
                  <tr>
                    <th>{{ $t("accountId") }}</th>
                    <th>{{ $t("currency") }}</th>
                    <th>{{ $t("platform") }}</th>
                    <th>{{ $t("demoLive") }}</th>
                    <th>{{ $t("accountType") }}</th>
                    <th>{{ $t("leverage") }}</th>
                    <th></th>
                  </tr>
                </thead>
                <tbody>
                  <tr class="selectHere" v-for="(list, index) in zuluAccounts">
                    <td>{{ list.account_id }}</td>
                    <td>
                      <img
                        :src="
                          '../../../../static/fxView/images/' +
                          currency[list.currency.toUpperCase()]
                        "
                        class="data_currency"
                      />
                    </td>
                    <td>{{ list.platform }}</td>
                    <td
                      v-html="parseInt(list.demo_live) == 0 ? 'demo' : 'live'"
                    ></td>
                    <td>{{ list.account_type }}</td>
                    <td>{{ list.leverage }}</td>
                    <td width="120">
                      <div class="d-flex align-items-center">
                        <router-link
                          :to="{
                            name: 'fxView.deposit',
                            params: {
                              account_id: list.account_id,
                              act_account_id: list.act_account_id,
                              currency: list.currency.toUpperCase(),
                            },
                          }"
                          class="prism_btn titleBG btn_xs"
                          >{{ $t("addFund") }}</router-link
                        >

                        <div class="position-relative ml-3">
                          <span
                            class="tableoption dotAreaForButton"
                            @click="
                              detailDiv(
                                index,
                                'buttons',
                                list.account_id,
                                list.act_account_id
                              )
                            "
                            ><feather
                              type="more-horizontal"
                              size="1rem"
                            ></feather
                          ></span>
                          <div
                            class="tablefilter box-shadow"
                            :ref="'buttons' + index"
                            v-if="parseInt(showButtonDetailInfo) == index"
                          >
                            <ul>
                              <li>
                                <router-link
                                  :to="{
                                    name: 'fxView.changeLeverage',
                                    params: {
                                      account_id: list.account_id,
                                      leverage: list.leverage,
                                      act_account_id: list.act_account_id,
                                      demo_live: list.demo_live,
                                      platform: list.platform,
                                    },
                                  }"
                                  >{{ $t("changeLeverage") }}</router-link
                                >
                              </li>
                              <li>
                                <router-link
                                  :to="{
                                    name: 'fxView.changePassword',
                                    params: {
                                      account_id: list.account_id,
                                      act_account_id: list.act_account_id,
                                      demo_live: list.demo_live,
                                      platform: list.platform,
                                    },
                                  }"
                                  >{{ $t("changePassword") }}</router-link
                                >
                              </li>
                              <li>
                                <router-link
                                  :to="{
                                    name: 'fxView.internalTransfer',
                                    params: {
                                      account_id: list.account_id,
                                      act_account_id: list.act_account_id,
                                      demo_live: list.demo_live,
                                      platform: list.platform,
                                      from_currency: list.currency,
                                    },
                                  }"
                                  >{{ $t("internalTransfer") }}</router-link
                                >
                              </li>
                              <li>
                                <a
                                  title="Act Web Trader Live"
                                  href="http://live.actforex.sysfx.com:8100/trade/actlite.jsp?entry=deal.245"
                                  target="_blank"
                                  v-if="list.platform == 'ACT'"
                                  >{{ $t("tradeNow") }}</a
                                >
                                <router-link
                                  :to="'/new-web-trade-link'"
                                  target="_blank"
                                  v-else-if="list.platform.toUpperCase() == 'MT4'"
                                  >{{ $t("tradeNow") }}</router-link
                                >
                                <router-link
                                  :to="'/web-trade-link'"
                                  target="_blank"
                                  v-else
                                  >{{ $t("tradeNow") }}</router-link
                                >
                              </li>
                            </ul>
                          </div>
                        </div>
                      </div>
                    </td>
                  </tr>
                </tbody>
              </table>
            </div>
          </div>
        </div>
      </div>
      <div v-else>
        <div v-if="congratulation_module">
          <div class="middleBox whitebox border radius mb-3">
            <div class="congratulations">
              <div class="logo_congrats">
                <img
                  src="../../../../static/fxView/images/check.svg"
                  alt="Congratulations"
                />
              </div>
              <div class="subtitle">
                <h3>
                  {{ $t("congo") }}
                  <span class="green"
                    >{{ get_user.profile.firstname }}
                    {{ get_user.profile.lastname }}</span
                  >
                </h3>
                <p>{{ $t("createAccountMsz1") }}</p>
                <ul class="includeWdth">
                  <li>
                    <strong> {{ $t("tradingId") }}</strong>
                    {{ account_detail.account_id }}
                  </li>
                  <!-- <li>
                    <strong> {{ $t("password") }}</strong
                    >{{ firstChar(account_detail.password) }}
                  </li> -->
                  <li>
                    <strong> {{ $t("leverage") }}</strong>
                    {{ account_detail.leverage }}
                  </li>
                  <li>
                    <strong> {{ $t("accountBaseCurrency") }}</strong>
                    {{ account_detail.currency }}
                  </li>
                </ul>
              </div>
              <div class="d-flex justify-content-center">
                <button
                  class="prism_btn btn_sm mr-2"
                  @click="() => closeForm()"
                >
                  Back
                </button>
                <router-link class="prism_btn btn_sm titleBG" to="/deposit">
                  {{ $t("fundNow") }}
                </router-link>
              </div>
              <p class="m-0 mt-2">
                You will receive the Zulu login details to login to ZuluTrade
                web portal
              </p>
            </div>
          </div>
        </div>
        <div v-else>
          <div
            class="stepForm"
            v-if="
              get_user.profile.firstname == '' ||
              get_user.profile.firstname == null ||
              get_user.mobile_no == '' ||
              get_user.mobile_no == null
            "
          >
            <div class="mainTitle text-center mt-4 mb-3">
              <h3 class="mb-4">{{ $t("personalInfo") }}</h3>
              <message-component
                :message="response_msg"
                :messageType="msg_type"
                v-if="response_msg != ''"
              ></message-component>
            </div>
            <div class="CustomBlockWidth inMiddle-area radius whitebox p-4">
              <div
                class="form-group field-wrapper"
                v-if="
                  get_user.profile.firstname == '' ||
                  get_user.profile.firstname == null
                "
              >
                <input
                  placeholder=" "
                  type="text"
                  v-model="f_name"
                  v-validate="'required'"
                  name="f_name"
                  class="float-field form-control"
                  :class="{
                    'is-invalid': personalInfoSubmitted && errors.has('f_name'),
                  }"
                  ref="f_nameInput"
                />
                <label for="password" class="float-label">{{
                  $t("fname")
                }}</label>
                <ul>
                  <li v-for="error in errors.collect('f_name')">{{ error }}</li>
                </ul>
              </div>
              <div
                class="form-group field-wrapper"
                v-if="
                  get_user.profile.lastname == '' ||
                  get_user.profile.lastname == null
                "
              >
                <input
                  placeholder=" "
                  type="text"
                  v-model="l_name"
                  class="float-field form-control"
                  v-validate="'required'"
                  name="l_name"
                  :class="{
                    'is-invalid': personalInfoSubmitted && errors.has('l_name'),
                  }"
                  ref="l_nameInput"
                />
                <label for="password" class="float-label">{{
                  $t("lname")
                }}</label>
                <ul>
                  <li v-for="error in errors.collect('l_name')">{{ error }}</li>
                </ul>
              </div>
              <!-- <div class="form-group field-wrapper" v-if="get_user.profile.firstname == '' && get_user.mobile_no == ''"> 
                        <vue-phone-number-input v-model="mobile_no"  :no-example="true" :default-country-code="userCountry" v-validate="{ max:15 }" ref="mobile_noInput" :class="{ 'is-invalid': submitted && errors.has('mobile_no') }" name="mobile_no" @update="updatedText"/>
                        <ul><li v-for="error in errors.collect('mobile_no')">{{ error }}</li></ul>
                        <p class="error" v-if="!(numberValid)">{{$t('InvalidNumber')}}</p>
                    </div>   v-if="get_user.profile.firstname != '' && get_user.mobile_no == ''"-->
              <div
                class="form-group field-wrapper"
                v-if="get_user.mobile_no == '' || get_user.mobile_no == null"
              >
                <vue-phone-number-input
                  v-model="mobile_no"
                  :no-example="true"
                  :default-country-code="userCountry"
                  v-validate="{ required: true, max: 15 }"
                  ref="mobile_noInput"
                  :class="{
                    'is-invalid': submitted && errors.has('mobile_no'),
                  }"
                  name="mobile_no"
                  @update="updatedText"
                />
                <ul>
                  <li v-for="error in errors.collect('mobile_no')">
                    {{ error }}
                  </li>
                </ul>
                <p class="error" v-if="!numberValid">
                  {{ $t("InvalidNumber") }}
                </p>
              </div>
              <div class="text-center">
                <!--  <a href="#" v-if="get_user.profile.firstname != '' && get_user.mobile_no == ''" @click="mobileShowvar = false" class="mr-3">skip</a> -->
                <button
                  class="prism_btn btn_sm"
                  v-on:click="submitPersonalInfo()"
                >
                  {{ $t("saveContinue") }}
                </button>
              </div>
            </div>
          </div>
          <div class="stepForm" v-else>
            <div class="mainTitle text-center mt-4 mb-3">
              <h3 class="mb-4">
                {{ $t("open") }}
                <span v-html="'Zulu'"></span>
                Live Trading Account
              </h3>
              <message-component
                :message="response_msg"
                :messageType="msg_type"
                v-if="response_msg != ''"
              ></message-component>
            </div>
            <div class="middleBox inMiddle-area radius whitebox p-4">
              <div class="row">
                <div class="col-12 mb-3">
                  <div class="slctcurrency">
                    <h4 class="mb-3">{{ $t("currency") }}</h4>
                    <ul>
                      <li
                        :class="select_currency == 'USD' ? 'selected' : ''"
                        @click="select_currency = 'USD'"
                      >
                        <img
                          src="../../../../static/fxView/images/usd.svg"
                          alt="usd"
                        />
                        {{ $t("USD") }}
                      </li>
                      <li
                        :class="select_currency == 'EUR' ? 'selected' : ''"
                        @click="select_currency = 'EUR'"
                      >
                        <img
                          src="../../../../static/fxView/images/eur.svg"
                          alt="eur"
                        />
                        {{ $t("EUR") }}
                      </li>
                      <li
                        :class="select_currency == 'GBP' ? 'selected' : ''"
                        @click="select_currency = 'GBP'"
                      >
                        <img
                          src="../../../../static/fxView/images/gbp.svg"
                          alt="gbp"
                        />
                        {{ $t("GBP") }}
                      </li>
                    </ul>
                  </div>
                </div>
                <div class="col-12 mb-3">
                  <input
                    type="hidden"
                    v-model="leverage"
                    v-validate="'required'"
                    class="float-field form-control"
                    :class="{
                      'is-invalid': submitted && errors.has('leverage'),
                    }"
                    ref="leverageInput"
                    name="leverage"
                  />
                  <div class="slctcurrency mb-lg-3">
                    <h4 class="mb-3">{{ $t("leverage") }}</h4>
                    <ul  v-if="get_user.pro_user == 1">
                      <li class="mb-lg-0"
                        :class="leverageDisabledFunc(key)"
                        @click="leverageSelectFuns(key)"
                        v-html="$t('pro' + key)"
                        v-for="(list, key) in leverageJsonPLCountry"
                        v-if="getUserProfile.residence_country == 'PL'"
                      ></li>
                      <li class="mb-lg-0"
                        :class="leverageDisabledFunc(key)"
                        @click="leverageSelectFuns(key)"
                        v-html="$t('pro' + key)"
                        v-for="(list, key) in leverageJson"
                        v-if="getUserProfile.residence_country != 'PL'"
                      ></li>
                    </ul>
                    <ul v-else>
                      <li class="mb-lg-0"
                        :class="leverageDisabledFunc(key)"
                        @click="leverageSelectFuns(key)"
                        v-html="$t('pro' + key)"
                        v-for="(list, key) in leverageJsonPLCountry"
                        v-if="getUserProfile.residence_country == 'PL'"
                      ></li>
                      <li class="mb-lg-0"
                        :class="leverageDisabledFunc(key)"
                        @click="leverageSelectFuns(key)"
                        v-html="$t('pro' + key)"
                        v-for="(list, key) in leverageJson"
                        v-if="getUserProfile.residence_country != 'PL'"
                      ></li>
                    </ul>
                    <!-- <ul v-if="errors.first('leverage')">
                      <li class="error">{{ $t("leverageField") }}</li>
                    </ul> -->
                    <p class="error" v-if="errors.first('leverage')">
                      <span>{{ $t("leverageField") }}</span>
                    </p>
                  </div>
                </div>
                <div class="col-12 col-md-12 border-top pt-3">
                  <div class="acPassword">
                    <h3 class="mb-3">{{ $t("password") }}</h3>
                  </div>
                  <div class="row mt-3">
                    <div class="col-12 col-md-6">
                      <div class="form-group field-wrapper">
                        <input
                          :type="inputtype"
                          placeholder=" "
                          v-model="password"
                          class="float-field form-control"
                          v-validate="{
                            required: true,
                            regex:
                              /^(?=.*[a-z])(?=.*[A-Z])(?=.*[0-9])(?=.*[!@#$%^*/])\S{5,15}$/,
                          }"
                          name="Trading Account Password"
                          :class="{
                            'is-invalid': submitted && errors.has('Trading Account Password'),
                          }"
                          ref="passwordInput"
                          @keyup="testing()"
                        />
                        <label for="password" class="float-label">
                          {{ $t("accountPassword") }}</label
                        >
                        <feather
                          :type="iconType"
                          class="toggle-password"
                          @click="switchVisibility('1')"
                        ></feather>
                        <p
                          class="error"
                          v-for="error in errors.collect('Trading Account Password')"
                          v-if="!submitError"
                        >
                          <span
                            v-show="error == 'The Trading Account Password field is required.'"
                            >{{ $t("tradeField") }}</span
                          >
                          <span
                            v-show="
                              error == 'The Trading Account Password field format is invalid.'
                            "
                            >{{ $t("passwordMust") }}</span
                          >
                        </p>
                        <p class="error" v-if="submitError">
                          <span>{{ $t("passwordMust") }}</span>
                        </p>
                      </div>
                    </div>
                    <div class="col-12 col-md-6">
                      <div class="form-group field-wrapper">
                        <input
                          :type="inputtype1"
                          placeholder=" "
                          v-model="confirmPassword"
                          class="float-field form-control"
                          v-validate="{ required: true, confirmed: password }"
                          name="Confirm Password"
                          :class="{
                            'is-invalid':
                              submitted && errors.has('Confirm Password'),
                          }"
                          ref="confirmPasswordInput"
                        />
                        <label for="password" class="float-label">
                          {{ $t("conPassword") }}</label
                        >
                        <feather
                          :type="iconType1"
                          class="toggle-password"
                          @click="switchVisibility('2')"
                        ></feather>
                        <p
                          class="error"
                          v-for="error in errors.collect('Confirm Password')"
                        >
                          <span
                            v-show="
                              error == 'The Confirm Password field is required.'
                            "
                            >{{ $t("passwordFieldReq1") }}</span
                          >
                          <!-- <span v-show="error == 'The confirmPassword field format is invalid.'">{{$t('passwordContain')}}</span> -->
                          <span
                            v-show="
                              error ==
                              'The Confirm Password confirmation does not match.'
                            "
                            >{{ $t("newConfFieldSame") }}</span
                          >
                        </p>
                      </div>
                    </div>
                  </div>
                </div>
                <div class="col-12 col-md-12 mt-3">
                  <div
                    class="full-width submitButton justify-content-center align-items-center d-flex mt-3 w-100"
                  >
                    <button
                      v-if="get_user.verified_status == 0"
                      disabled
                      class="disabled prism_btn btn_sm"
                    >
                      {{ $t("suceessMsz24") }}
                    </button>
                    <button
                      v-else
                      class="prism_btn btn_sm"
                      v-on:click="submit()"
                    >
                      {{ $t("createAccount") }}
                    </button>
                  </div>
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>
  </div>
</template>
<script>
import { fxViewMixins } from "@/plugins/fxView";
import * as types from "@/types";
import { mapActions } from "vuex";
import moment from "moment";

export default {
  name: "CREATE-ACCOUNT",
  mixins: [fxViewMixins],
  data() {
    return {
      showButtonDetailInfo: "",
      date: moment().format("Do MMM, YYYY"),
      mszValidation: "",
      submitError: false,
      pageLoader: false,
      response_msg: "",
      agreeTerms: false,
      showStep: true,
      msg_type: "",
      userCountry: "IN",
      select_currency: "EUR",
      account_type: "CLASSIC",
      platform: "MT4",
      leverage: "",
      password: "",
      confirmPassword: "",
      error_msg_password: "",
      submitted: false,

      f_name: "",
      m_name: "",
      l_name: "",
      mobile_no: "",
      mobileShowvar: false,
      show_mob: true,
      personalInfoSubmitted: false,

      congratulation_module: false,
      account_detail: {},

      inputtype: "password",
      showpassword: false,
      iconType: "eye-off",
      inputtype1: "password",
      showpassword1: false,
      showForm: false,
      iconType1: "eye-off",
      numberValid: true,
      demo_live_select: "1",
      numberWithCountry: "",
      platformJson: {
        MT5: {
          window:
            "https://download.mql5.com/cdn/web/fxview.uk.ltd/mt5/fxview5setup.exe",
          ios: "https://apps.apple.com/us/app/metatrader-5/id413251709",
          android:
            "https://play.google.com/store/apps/details?id=net.metaquotes.metatrader5",
          web: "/web-trade-link",
        },
        MT4: {
          window:
            "https://download.mql5.com/cdn/web/fxview.uk.ltd/mt4/fxview4setup.exe",
          ios: "https://apps.apple.com/us/app/metatrader-4/id496212596",
          android:
            "https://play.google.com/store/apps/details?id=net.metaquotes.metatrader4",
          web: "/new-web-trade-link",
        },
        ACT: {
          window: "http://setup.sysfx.com/setup/trader/fxview/trader_setup.exe",
          ios: "https://www.apple.com/ios/app-store/",
          android:
            "https://play.google.com/store/apps/details?id=fxview.trader",
          web: "http://demo.actforex.sysfx.com:8100/trade/actlite.jsp?entry=demo.245",
        },
        ZULU: {
          window: "",
          ios: "",
          android: "",
          web: "",
        },
      },
    };
  },
  computed: {
    zuluAccounts() {
      if (
        this.liveAccountList.totalRecords &&
        this.liveAccountList.totalRecords > 0
      ) {
        return this.liveAccountList.records.filter((i) => i.platform == "ZULU");
      } else {
        return [];
      }
    },
    OnlyUsers() {
      // console.log(this.get_user.profile.user_id);
      return [4504, 681].includes(this.get_user.profile.user_id)
    }
  },
  methods: {
    hasConsent() {
      let roles = this.get_user.roles.split("&");
      if (roles.length > 1 && roles.includes("ZULU")) return true;
      return false;
    },
    refetchUserData() {
      this._runFreshUserData();
    },
    submitConsent() {
      const _that = this
      let inputJson = {
        globalParams: {},
        localParams: { parameter: _that},
      };
      this._runSubmitConsent(inputJson);
    },
    testing() {
      var specialArray = [
        "!",
        "@",
        "#",
        "$",
        "%",
        "^",
        "&",
        "*",
        "(",
        ")",
        "_",
        "-",
        "+",
        "=",
        "[",
        "]",
        "{",
        "}",
        ";",
        ":",
        '"',
        "/",
        "?",
        ".",
        ">",
        "<",
        "|",
        "/",
        "*",
        ",",
      ];
      var specialArrayAccept = ["!", "@", "#", "$", "%", "^", "*", "/"];
      let truVar = "";

      for (let i = 0; i <= this.password.length - 1; i++) {
        if (specialArray.indexOf(this.password[i]) > 0) {
          if (specialArrayAccept.indexOf(this.password[i]) == -1) {
            truVar = "1";
          }
        }

        if (i == this.password.length - 1) {
          if (truVar == "1") {
            this.submitError = true;
          } else {
            this.submitError = false;
          }
        }
      }
    },
    leverageSelectFuns(getKey) {
      if (parseInt(this.get_user.pro_user) == 1) {
        if (parseInt(getKey) != 30) {
          this.leverage = getKey;
        } else {
          this.leverage = "";
        }
      } else {
        if (parseInt(getKey) == 30) {
          this.leverage = getKey;
        } else {
          this.leverage = "";
        }
      }
    },
    leverageDisabledFunc(getKey) {
      if (parseInt(this.get_user.pro_user) == 1) {
        if (parseInt(getKey) == 30) {
          return "disabled";
        } else if (parseInt(this.leverage) == parseInt(getKey)) {
          return "selected";
        } else {
          return "";
        }
      } else {
        if (
          parseInt(this.leverage) == parseInt(getKey) &&
          parseInt(this.leverage) == 30
        ) {
          return "selected";
        } else if (parseInt(getKey) != 30) {
          return "disabled";
        } else {
          return "";
        }
      }
    },
    updatedText(e) {
      this.numberWithCountry = e.formattedNumber;
      this.numberValid = e.isValid;
    },
    firstChar(getPassword) {
      let first = getPassword.charAt(0);
      let last = getPassword.charAt(getPassword.length - 1);
      return first + "*****" + last;
    },
    switchVisibility(getData) {
      if (getData == "1") {
        this.showpassword = !this.showpassword;
        if (this.showpassword) {
          this.inputtype = "text";
          this.iconType = "eye";
        } else {
          this.inputtype = "password";
          this.iconType = "eye-off";
        }
      } else {
        this.showpassword1 = !this.showpassword1;
        if (this.showpassword1) {
          this.inputtype1 = "text";
          this.iconType1 = "eye";
        } else {
          this.inputtype1 = "password";
          this.iconType1 = "eye-off";
        }
      }
    },
    ...mapActions({
      _runSaveUserName: types.RUN_SAVE_USER_NAME,
      _runFreshUserData: types.RUN_STATE_LOAD,
    }),
    submitPersonalInfo() {
      const _that = this;
      _that.personalInfoSubmitted = true;
      _that.$validator.validate().then((valid) => {
        if (valid) {
          let inputJson = {
            globalParams: {
              fname: _that.f_name,
              mname: _that.m_name,
              lname: _that.l_name,
              mobile_no: _that.numberWithCountry,
            },
            localParams: { parameter: _that },
          };
          _that._runSaveUserName(inputJson);
        } else {
          _that.handleValidationErrorAdvanced(_that.errors);
        }
      });
    },
    submit() {
      const _that = this;
      _that.submitted = true;
      _that.$validator.validate().then((valid) => {
        if (valid && !_that.submitError) {
          const plt = _that.platform === "MT4" ? "ZULU" : _that.platform + "-ZULU";
          let accountJson = {
            globalParams: {
              currency: _that.select_currency,
              account_type: _that.account_type,
              platform:  plt,   //_that.platform,
              leverage: _that.leverage,
              password: _that.password,
              demo_live: _that.demo_live_select.toString(),
            },
            localParams: { parameter: _that },
          };
          _that._runCreateAccount(accountJson);
        } else {
          _that.handleValidationErrorAdvanced(_that.errors);
        }
      });
    },
    detailDiv(index, getData, account_id, act_account_id) {
      if (getData == "div") {
        if ($(this.$refs[getData + index]).hasClass("hide")) {
          $(this.$refs[getData + index]).removeClass("hide");
        } else {
          $(this.$refs[getData + index]).addClass("hide");
        }
      } else {
        if (parseInt(this.showButtonDetailInfo) == index) {
          this.showButtonDetailInfo = "";
        } else {
          this.showButtonDetailInfo = index;
        }
      }
    },
    closeForm() {
      this.congratulation_module = !this.congratulation_module;
      this.showForm = !this.showForm;
    },
    createAccountEvent(){
      this.showStep = false;
      this.$trackEvent('CP+ZuluTrade+Create+Zulu+Account')
    }
  },
  mounted() {
    // this.closeForm();
    const _that = this;
    $(".costompopup .creat-account").click(function () {
      _that.congratulation_module = false;
    });
   
    $(document).on("click", function(event){
        if(!$(event.target).closest('.dotAreaForButton').length){
            _that.showButtonDetailInfo = ''
        }
    });
        
  },
  created() {
    if (this.get_user.pro_user != 1) {
      this.leverage = "30";
    }
    if (
      this.get_user.profile.firstname != "" &&
      this.get_user.profile.firstname != null
    ) {
      this.f_name = this.get_user.profile.firstname;
    }
    if (
      this.get_user.profile.lastname != "" &&
      this.get_user.profile.lastname != null
    ) {
      this.l_name = this.get_user.profile.lastname;
    }

    if (this.get_user.mobile_no != "" && this.get_user.mobile_no != null) {
      this.mobile_no = this.get_user.mobile_no;
    } else {
      this.mobileShowvar = true;
    }
  },
};
</script>



// WEBPACK FOOTER //
// src/components/fxView/zulutrade/zulutrade.vue